import React from "react";
import {useHistory} from "react-router-dom";
import {Button, Chip, Link, TableCell, TableRow} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import {dateUtils} from "../utils";
import {
    ActionItems as CurrentActionsItems,
    cashStreamSlug,
    ClientAI,
    GWT_GEN2_STRATEGY,
} from "../constants";
import {isDebug, joinAsFullName} from "../utils/commonUtils";
import {history} from "../configureStore";

const AgentActionTypeButton = (props: {
    actionItem: any,
    getEnvelope: Function,
    setClientDetail: Function,
    setCoverLetterUpload: Function,
    setCoverLetterDialog: Function,
    history: any
    role: number
    setViewIllustrationRequest: any | Function;
}) => {
    const { actionItem, getEnvelope, setClientDetail, setCoverLetterDialog, setCoverLetterUpload, role } = props;
    const clientPolicy = actionItem && actionItem.clientPolicy;
    const offerType = (clientPolicy && clientPolicy.underWritingOfferTypeFinal) || (clientPolicy && clientPolicy.underWritingOfferType);
    const navigateTo = useHistory();
    

    if (actionItem.actionType === "COVER_LETTER_REQUIRED" ||
            actionItem.actionType === "TAX_DOCUMENT_INCOME_EARNER" ||
            actionItem.actionType === "TAX_DOCUMENT_SPOUSE" ||
            actionItem.actionType === "TAX_DOCUMENT_WEALTH_TRANSFER") {

        return <Button
                className="textBlue"
                size="small"
                variant="outlined"
                color="primary"
                disabled={actionItem.status === 1 || role === 3}
                onClick={() => {
                    if (actionItem.status === 0) {
                        setClientDetail({ ...actionItem });
                        setTimeout(() => {
                            if (actionItem.actionType !== "COVER_LETTER_REQUIRED") {
                                setCoverLetterUpload(false);
                            }
                            setCoverLetterDialog(true);
                        }, 0);
                    }
                }}
        >
            {actionItem.status === 0 ? CurrentActionsItems[actionItem.actionType].actionButton : "Uploaded Cover Letter"}
        </Button>;
    } else if (actionItem && actionItem.actionType === "GREAT_WEALTH_TRANSFER") {
        return (
                <Button
                        className="btnSmall textBlue"
                        color="primary"
                        onClick={() => navigateTo.push(`/new-client/detail/${(actionItem.client && actionItem.client.id)}/${(clientPolicy && clientPolicy.id)}/case-details`)}
                        size="small"
                        type={"button"}
                        variant="outlined"
                        disabled={role === 3}
                >
                    {CurrentActionsItems[actionItem.actionType].actionButton}
                </Button>
        );
    } else if (actionItem && actionItem.actionType === CurrentActionsItems.ILLUSTRATION_CHANGES_REQUESTED.actionType && actionItem.status === 0) {
        return (
                <Button
                        className="btnSmall textBlue"
                        color="primary"
                        disabled={role === 3}
                        onClick={() => props.setViewIllustrationRequest(actionItem)}
                        size="small"
                        type="button"
                        variant="outlined"
                >
                    {CurrentActionsItems[actionItem.actionType].actionButton}
                </Button>
        );
    } else if (actionItem && actionItem.actionType === CurrentActionsItems.ILLUSTRATION_CHANGES_REQUESTED.actionType && actionItem.status === 1) {
        return (
                 <span>
                        {actionItem.actionMessage}
                 </span>
        );
    }
    return <Button
            size="small"
            variant="outlined"
            color="primary"
            disabled={
                // cover letter 1 or (additional tax 1 and Not Gen2 type)
                    (clientPolicy && (clientPolicy.coverLetterReq === 1 || (clientPolicy.strategy && clientPolicy.strategy.id !== GWT_GEN2_STRATEGY && clientPolicy.additionalTaxDocReq === 1) || role === 3)) || false
            }
            onClick={() => {
                actionItem.status === 0 ? getEnvelope(actionItem.enrollmentId, "", offerType) : getEnvelope(actionItem.enrollmentId, 2, offerType);
            }}
    >
        {actionItem.status === 0 ?
                clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug !== cashStreamSlug ? "Sign Application Docs" : "Approve Application Docs"
                : "Signed Application (View)"}
    </Button>;
};

const getAgentName = (agent: any) => {
    return agent.user ? (agent.user.firstName + " " + agent.user.lastName) : "";
};

function ActionItemListRow(props: {
    actionItem: any,
    role: number,
    history: any,
    getEnvelope: Function,
    getActionName: Function,
    setClientDetail: Function
    actionItemSelected: any,
    type: string,
    userName: string,
    createTicket: Function,
    resolveTicket: Function,
    viewProposal: Function,
    handleRequestModification: Function,
    getAdminButton: Function,
    setCoverLetterDialog: Function,
    setCoverLetterUpload: Function,
    isViaAgentApprovalPage: boolean,
    setViewIllustrationRequest: any | Function;
}) {
    const {
        actionItem,
        role,
        getEnvelope,
        getActionName,
        setClientDetail,
        actionItemSelected,
        createTicket,
        isViaAgentApprovalPage,
        type,
        userName,
        resolveTicket,
        viewProposal,
        handleRequestModification,
        getAdminButton,
        setCoverLetterDialog,
        setCoverLetterUpload,
        setViewIllustrationRequest,
    } = props;
    const processedBy = actionItem && actionItem.user ? `${actionItem.user.firstName} ${actionItem.user.lastName}` : ``;
    const clientPolicy = actionItem && actionItem.clientPolicy;
    const clientPolicyId = actionItem.clientPolicyId
    let additionalDocName = "";
    let docReqText = "";
    const offerType = clientPolicy && clientPolicy.underWritingOfferType || clientPolicy && clientPolicy.underWritingOfferTypeFinal;
    const isGWTGen2 = clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id === GWT_GEN2_STRATEGY;
    if (actionItem && actionItem.actionType === "GREAT_WEALTH_TRANSFER" && clientPolicy && clientPolicy.coverLetterReq === 1) {
        docReqText = "This is a Great Wealth Transfer Case. Please complete the GWT section in case details for this case.";
    }
    if (!isGWTGen2 && actionItem && actionItem.actionType === "SIGN_AGENT" && clientPolicy && clientPolicy.coverLetterReq === 1) {
        docReqText = "A cover letter must be added before agent can sign application";
    }
    if (!isGWTGen2 && actionItem && actionItem.actionType === "SIGN_AGENT" && clientPolicy && clientPolicy.additionalTaxDocReq === 1) {
        if (clientPolicy && clientPolicy.currentlyEmployed.toLowerCase() === "other") {
            if (clientPolicy.parentsAreIncomeEarner) {  //WT
                additionalDocName = `Wealth Transfer docs`;
            } else {
                additionalDocName = `Income Earner docs`;
            }
        } else if (clientPolicy && clientPolicy.usingSpouseIncome === 1) {
            additionalDocName = `Spouse docs`;
        }
        if (!docReqText) {
            docReqText = `${additionalDocName} must be added before agent can sign application`;
        } else { // case if cover letter requirement is there
            docReqText = `A cover letter and ${additionalDocName} must be added before agent can sign application`;
        }
    }

    const onNameClick = () => {
        const postPath: string = role === 12 ? "profile" : "action-items";
        return props.history.push(`/new-client/detail/${(actionItem.client && actionItem.client.id)}/${(clientPolicy && clientPolicy.id)}/${postPath}`)
    };

    return <>
        <TableRow hover key={actionItem.id} data-nick-debug={isDebug() ? JSON.stringify(actionItem) : actionItem.actionType}>
            <TableCell>
                {
                        actionItem.client &&
                        (
                                <Tooltip
                                        arrow
                                        placement="right-start"
                                        title={
                                            <Typography
                                                    variant="caption"
                                                    className="mb0"
                                            > Take me to clients details screen. </Typography>
                                        }
                                >
                                    <>
                                    <Link onClick={onNameClick}>
                                        {/*<Link onClick={() => props.history.push("/new-client/detail/" + ((actionItem.client && actionItem.client.id + `/${role === 12 ? "details" : role === 4 ? "case-details" : "action-items"}`) || ""))}>*/}
                                            {joinAsFullName(actionItem.client.user)} {isGWTGen2 && <Chip className={"ml5"} label="GWT" size="small" />}
                                        </Link>
                                        {[CurrentActionsItems.TRUSTEE_REJECTED_BENEFICIARY.actionType, CurrentActionsItems.TRUSTEE_REJECTED_NAME_CHANGE.actionType ].includes(actionItem.actionType) && <Chip label="Trust" size="small" />}
                                    </>
                                </Tooltip>
                        )
                }
                {
                        actionItem.agent && !actionItem.client &&
                        <Tooltip arrow title={`Agent - ${getAgentName(actionItem.agent)}`}>
                            <span>{getAgentName(actionItem.agent)}</span>
                        </Tooltip>
                }
            </TableCell>
            <TableCell>
                {
                    getActionName(actionItem)
                }
            </TableCell>
            {
                    (role !== 4 && role > 2) && (
                            <TableCell>{actionItem.agent.user.firstName + " " + actionItem.agent.user.lastName}</TableCell>
                    )
            }
            { actionItem.status === 1 && type === "servicing" && <TableCell>{ dateUtils.asDbDateFormat(actionItem.createdAt) }</TableCell> }
            <TableCell>{dateUtils.asDbDateFormat((actionItem.status === 0 || actionItem.status === 2) ? actionItem.createdAt : actionItem.updatedAt)}</TableCell>
            {/* Action Item once rejected will not be updated again...so that is why we used updatedAt for date of rejection */}
            { actionItem.status === 2 && type === "servicing" && <TableCell>{ dateUtils.asDbDateFormat(actionItem.updatedAt) }</TableCell> }
            {
                    role <= 2 && !isViaAgentApprovalPage &&
                    <TableCell>
                        {clientPolicy && clientPolicy.strategy && (clientPolicy.strategy.displayName ? clientPolicy.strategy.displayName : clientPolicy.strategy.name)}
                    </TableCell>
            }
            {
                    role <= 2 && !isViaAgentApprovalPage &&
                    <TableCell>
                        {clientPolicy && clientPolicy.tranche && clientPolicy.tranche.trancheNumber}
                    </TableCell>
            }
            {
                    (role > 3 && !isViaAgentApprovalPage) &&
                    <TableCell>
                        {clientPolicy && clientPolicy.imo && clientPolicy.imo.region}
                    </TableCell>
            }
            {/*{
                    role > 2 && !isViaAgentApprovalPage && (actionItem.status === 0 || type !==  'servicing') &&
                    <TableCell>
                        <TicketButton
                                ticketId={actionItem.currentTicket}
                                disabled={actionItemSelected === actionItem}
                                onCreateTicket={({
                                                    detail,
                                                    files,
                                                }) => createTicket(actionItem, detail, files, clientPolicy.id)}
                                onResolveTicket={resolveTicket} />
                    </TableCell>
            }*/}
            
            {
                    role <= 2 && !isViaAgentApprovalPage && type ===  'servicing' && actionItem.status !== 0 &&
                    <TableCell>
                        {processedBy}
                    </TableCell>
            }
            {
                role === 4 || role === 3 ?
                        <TableCell>
                            {
                                actionItem.actionType === "VIEW_APPROVE" ?
                                        <Button
                                                size="small"
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {
                                                    viewProposal(actionItem.id, actionItem.enrollmentId, actionItem.status, actionItem.clientPolicy);
                                                }}
                                                disabled={role === 3}
                                        >
                                            {actionItem.status === 0 ? "View and Approve Proposal" : "View Proposal"}
                                        </Button> :
                                        <>
                                            {
                                                docReqText &&
                                                <Typography className="colorRed">{docReqText}</Typography>
                                            }
                                            {
                                                ClientAI.ID_DOC_EXPIRED.actionType != actionItem.actionType &&
                                                <AgentActionTypeButton
                                                        actionItem={actionItem}
                                                        getEnvelope={getEnvelope}
                                                        setClientDetail={setClientDetail}
                                                        setCoverLetterUpload={setCoverLetterUpload}
                                                        setCoverLetterDialog={setCoverLetterDialog}
                                                        history={props.history}
                                                        role={role}
                                                        setViewIllustrationRequest={setViewIllustrationRequest}
                                                />
                                            }
                                        </>
                            }
                            {
                                    CurrentActionsItems.VIEW_APPROVE.actionType === actionItem.actionType && actionItem.status === 0 &&
                                    <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            className="btnSmall"
                                            type={"button"}
                                            onClick={() => handleRequestModification(actionItem.enrollmentId)}
                                            disabled={role === 3}
                                    >
                                        Request Modification
                                    </Button>
                            }
                            {
                                    ClientAI.PARENT_REVIEW_APPROVE.actionType === actionItem.actionType &&
                                    <Button
                                            size="small"
                                            variant="outlined"
                                            color="primary"
                                            className="floatLeft mt20 ml5"
                                            type={"button"}
                                            onClick={() => handleRequestModification()}
                                            disabled={role === 3}
                                    >
                                        Request Modification
                                    </Button>
                            }

                            {
                                CurrentActionsItems.ID_DOC_EXPIRED.actionType === actionItem.actionType &&
                                <Button
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            history.push(`/new-client/detail/${actionItem.client && actionItem.client.id}/${clientPolicyId}/documents`);
                                        }}
                                >
                                    {CurrentActionsItems.ID_DOC_EXPIRED.actionButton}
                                </Button>
                            }
                        </TableCell> :
                        <TableCell>
                            {
                                    (role === 1 || role === 2 || role === 12) &&
                                    getAdminButton(actionItem.actionType, CurrentActionsItems[actionItem.actionType] ? CurrentActionsItems[actionItem.actionType].actionButton : "", role, actionItem, offerType)
                            }
                        </TableCell>
            }
        </TableRow>

    </>;
}

export default ActionItemListRow;